<script setup lang="ts">

import type NewsItem from "@/types/NewsItem.ts";
import { computed } from 'vue'
import NewsItemBaseStructure from '@/components/Sections/News/Types/Base/NewsItemBaseStructure.vue'
import NewsItemBase from '@/components/Sections/News/Types/Base/NewsItemBase.vue'
import { CDN } from '@/models/cdn.ts'
import MetricDisplay from '@/components/Elements/Generic/MetricDisplay.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
  newsItem: NewsItem,
  toast: boolean
}>();

const formatPopulation = computed(() => {
  return parseInt(props.newsItem.contentData.population).toLocaleString()
})

</script>

<template>
  <NewsItemBase
    :toast="toast"
    :toast-image="CDN.technology(64, 'ringworlds')"
    :toast-text="t('news.types.ringworldCreated.toast', { name: props.newsItem.contentData.ringworldName })"
  >
      <NewsItemBaseStructure
        :newsItem="props.newsItem"
        :item-image="CDN.technology(512, 'ringworlds')"
        :header="t('news.types.ringworldCreated.title', { name: props.newsItem.contentData.ringworldName, star: props.newsItem.contentData.starName })"
      >
        <div class="flex flex-col justify-between h-full">
          <div class="flex-grow" v-html="t('news.types.ringworldCreated.body', { name: props.newsItem.contentData.ringworldName, star: props.newsItem.contentData.starName })"></div>
          <div class="flex justify-end pt-2">
            <MetricDisplay :text="t('news.types.ringworldCreated.population')">
              <span class="text-green-500">{{ formatPopulation }}</span>
            </MetricDisplay>
          </div>
        </div>
      </NewsItemBaseStructure>
  </NewsItemBase>
</template>

<style scoped lang="scss">

</style>